export const GOOGLE_ADS_ACTION_UPDATE_PTO_ADS = 'update-pto-ads';
